import { AppBar } from '@mui/material';
import { styled } from '@mui/system';
import { MarginContainer } from '@zignaly-open/ui';

export const StyledAppBar = styled(AppBar)`
  position: sticky;
`;

export const Container = styled(MarginContainer)`
  display: flex;
  justify-content: space-between;
`;
